import axios from 'axios'
import get from 'lodash.get'
import config from '@src/config'

const tableServiceGateway = config.tableServiceGateway

export const getBasket = async ({ siteId, salesAreaId, tableNumber }) => {
  try {
    if (!siteId) {
      throw new Error('siteId not defined')
    }
    if (!salesAreaId) {
      throw new Error('salesAreaId not defined')
    }
    if (!tableNumber) {
      throw new Error('tableNumber not defined')
    }

    const url = `${tableServiceGateway}/site/${siteId}/area/${salesAreaId}/table/${tableNumber}`
    const res = await axios.get(url)

    if (!res.data || (!res.data.accountBreakdown && !res.data.braintreeToken)) {
      throw new Error('Response is in an unexpected format')
    }

    const { accountBreakdown, braintreeToken } = res && res.data

    const outstandingBalanceToPay = get(
      accountBreakdown,
      'account.outstandingBalanceToPay'
    )
    const totalIncludingDiscount = get(
      accountBreakdown,
      'account.outstandingBalanceToPay'
    )
    const basketId = get(accountBreakdown, 'account.basketId')
    const accountId = get(accountBreakdown, 'account.accountId')
    const account = get(accountBreakdown, 'account.account')

    if (outstandingBalanceToPay === 0) {
      throw new Error(res)
    }

    // Map bill items
    const billItems = [...account]
      .map((item, index) => ({
        id: index,
        name: item.display && item.display.name,
        price: item.tariffPrice || 0,
        choices:
          (item.choiceLines &&
            [...item.choiceLines].map((choice, index) => ({
              id: index,
              name: choice.display.name,
              price: choice.tariffPrice,
            }))) ||
          [],
      }))
      // Remove discount items
      .filter((item) => item.name)
      // Remove 'None' items from choices
      .map((item) => {
        const choices = item.choices.filter((choice) => choice.name !== 'None')
        const updatedItem = {
          ...item,
          choices,
        }
        return updatedItem
      })

    // Get discount amount
    const discountItems = [...account].filter(
      (item) => item.discountId || item.promotionId
    )
    const discount =
      (discountItems.length &&
        (Math.abs(discountItems[0].Amount) ||
          Math.abs(discountItems[0].amount))) ||
      0

    // Calculate original amount without discount applied
    const total = (
      parseFloat(totalIncludingDiscount || 0) + parseFloat(discount || 0)
    ).toFixed(2)

    const billQuantity = billItems.length

    // TODO: Validation that we have all needed vars

    return Promise.resolve({
      accountId,
      basketId,
      billItems,
      billQuantity,
      total,
      totalIncludingDiscount,
      discount,
      braintreeToken: braintreeToken.clientToken,
    })
  } catch (err) {
    // TODO: sentry log
    // TODO: remove console.log
    console.log('tsGetBasket err: ', err)
    return Promise.reject(err)
  }
}
